<template>
  <div class="ts-button-wrapper" :class="{ active }">
    <Button class="ts-button" :class="{ active, filled, pending }" v-bind="$attrs" v-on="$listeners"
      ><slot></slot
    ></Button>
  </div>
</template>

<style lang="scss" scoped>
.ts-button-wrapper {
  display: inline-block;

  .active {
    background: #99ffd1;
    border-radius: 47px;
  }
}

.ts-button {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.32);
  box-shadow: -8px -8px 16px 0 rgba(250, 251, 255, 0.8), 8px 8px 16px 0 rgba(166, 171, 189, 0.8);
  border-radius: 47px;
  transition: box-shadow 0.3s ease-in-out;

  padding: 18px 24px;
  width: 100%;

  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  color: #6d7587;

  &.el-button--primary,
  &.el-button--primary:hover,
  &.el-button--primary:focus,
  &.el-button--primary:active {
    color: #39c88c;

    &.filled {
      border: solid 2px rgba(255, 255, 255, 0.32);
      background-blend-mode: normal, soft-light, normal;
      background-image: linear-gradient(to bottom, #99ffd1, #99ffd1), linear-gradient(281deg, #000000 100%, #ffffff 0%),
        linear-gradient(to bottom, #ebecf0, #ebecf0);
      box-sizing: border-box;
      background-color: #99ffd1;
      color: black;
    }
  }

  &.el-button--small,
  &.el-button--mini {
    border-radius: 16px;
    font-size: 12px;
    padding: 7px 12px;
    box-shadow: -5px -5px 10px 0 rgba(250, 251, 255, 0.8), 5px 5px 10px 0 rgba(166, 171, 189, 0.48);

    &:hover,
    &:focus {
      box-shadow: -10px -10px 16px 0 #fafbff, 8px 8px 16px 0 #a6abbd;
    }

    &.is-circle {
      width: 32px;
      height: 32px;
      padding: 0;
    }
  }

  &.el-button--mini {
    &.is-circle {
      width: 24px;
      height: 24px;
      padding: 0;
    }
  }

  &.is-disabled {
    font-family: Roboto;
    color: #acbacc;
  }

  &.pending {
    position: relative;
    color: #acbacc;
    &:hover {
      color: #acbacc;
    }
  }

  &:hover,
  &:focus {
    background: #ebecf0;
    background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
    background-blend-mode: soft-light, normal;
    background-clip: padding-box;
    border: 2px solid rgba(255, 255, 255, 0.32);
    box-shadow: -16px -16px 32px 0 #fafbff, 16px 16px 32px 0 #a6abbd;
    border-radius: 47px;

    color: #565c66;

    &.is-disabled {
      font-family: Roboto;
      color: #acbacc;
    }
  }

  &:active {
    background: #ebecf0;
    background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
    background-blend-mode: soft-light, normal;
    background-clip: padding-box;
    border: 2px solid rgba(255, 255, 255, 0.32);
    box-shadow: inset -8px -8px 16px 0 #fafbff, inset 8px 8px 16px 0 #a6abbd;
    border-radius: 47px;

    color: #242424;
  }

  &.is-circle {
    width: 48px;
    height: 48px;
    padding: 0;
  }

  &.active {
    background: #99ffd1;
    background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
    background-blend-mode: soft-light, normal;
    background-clip: padding-box;
    border: 2px solid rgba(255, 255, 255, 0.16);
    box-shadow: -5px -5px 10px 0 rgba(250, 251, 255, 0.8), 5px 5px 10px 0 rgba(166, 171, 189, 0.48);

    color: #242424;
  }
}
.ts-button.pending {
  cursor: not-allowed;
}
</style>

<script>
import { Button } from 'element-ui';

export default {
  name: 'TsButton',
  components: {
    Button
  },
  props: {
    pending: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
